<template>
  <div class="AppBulkList" data-locator="app-bulk-list">
    <AppBulkListItem
      @click="toggleSummary"
      class="clickable"
      data-locator="app-bulk-list-toggle"
    >
      <span>{{ displayedToggleLabel }}</span>
      <app-badge variant="info" size="small">
        {{ itemsCount }}
      </app-badge>

      <app-material-icon
        :name="isOpened ? 'chevron-up' : 'chevron-down'"
        type="fa"
        class="ml-auto"
        size="xxs"
      />
    </AppBulkListItem>

    <transition-group name="app-fade">
      <div
        v-if="isOpened"
        class="AppBulkList__items-wrapper"
        data-locator="app-bulk-list-items"
      >
        <AppBulkListItem
          v-for="(item, index) in items"
          :key="index"
          data-locator="app-bulk-list-item"
        >
          <slot :item="item">{{ item }}</slot>
        </AppBulkListItem>
      </div>
    </transition-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppBulkListItem from '@/common/app-bulk-list/AppBulkListItem.vue'

export default defineComponent({
  name: 'AppBulkList',
  components: {
    AppBulkListItem,
  },
  props: {
    items: {
      type: Array as PropType<Array<any>>,
      default: () => [],
    },
    itemsName: {
      type: String,
      default: 'common.app-bulk-list.defaultItemsName',
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:opened'],
  data () {
    return {
      isOpened: this.defaultOpen,
    }
  },
  computed: {
    displayedToggleLabel (): string {
      return this.$t(
        this.isOpened
          ? 'common.app-bulk-list.toggleLabel.hide'
          : 'common.app-bulk-list.toggleLabel.show',
        { itemsName: this.itemsName },
      ) as string
    },
    itemsCount (): number {
      return this.items.length
    },
  },
  methods: {
    toggleSummary () {
      this.isOpened = !this.isOpened
      this.$emit('update:opened', this.isOpened)
    },
  },
})
</script>

<style lang="scss" scoped>
.AppBulkList {
  &__items-wrapper {
    margin-top: 16px;
    max-height: 260px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
